import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((cfg) => {
    const token = localStorage.getItem("av_token");
    if (token) cfg.headers.Authorization = `Bearer ${token}`;
    return cfg;
});

export function apiErr(e, fallback = "Algo salió mal. Intenta de nuevo.") {
    const d = e?.response?.data?.detail;
    if (typeof d === "string") return d;
    if (Array.isArray(d)) return d.map((x) => x?.msg || "").join(" ") || fallback;
    return fallback;
}
